import { ArticleHeading4, ArticleParagraph1 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './OfficeCard.css';
import { IOffice } from '../../types/builder';

export interface IOfficeCardProps {
  office: IOffice;
  phoneButton: React.ReactNode;
}

export const OfficeCard: React.FC<IOfficeCardProps> = ({ office, phoneButton }) => {
  return (
    <div>
      <ArticleHeading4>{office.address}</ArticleHeading4>
      <div className={styles['description']}>
        <ArticleParagraph1>{office.description}</ArticleParagraph1>
      </div>
      {phoneButton}
    </div>
  );
};
